import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { useI18n } from 'next-localization';
import AccordionDefault from 'components/Sections/Accordion/AccordionDefault';

type Props = {
  children: React.ReactNode;
  id?: string;
  fields: {
    title?: Field<string>;
    transcript?: Field<string>;
  };
};

const PodcastBase = ({ children, id, fields }: Props) => {
  const { t } = useI18n();

  return (
    <div id={id} className="mt-4">
      <Text tag="h4" className="mb-3" field={fields.title} />
      {children}
      {fields.transcript?.value && (
        <AccordionDefault
          title={{ value: t('transcript') }}
          description={fields.transcript}
          className="w-100 mt-3 py-1.5"
        />
      )}
    </div>
  );
};

export default PodcastBase;
